{
	"actions": {
		"cancel": "Annulla",
		"end_every_session": "Termina tutte le sessioni di questa persona",
		"end_session": "Termina questa sessione",
		"open_menu": "Apri il menu delle azioni",
		"sign_out": "Esci"
	},
	"columns": {
		"actions": "Azioni",
		"address": "Indirizzo",
		"device": "Dispositivo",
		"last_activity": "Ultima attività",
		"person": "Persona",
		"started_at": "Inizio"
	},
	"empty": {
		"description": "Qui compaiono gli accessi aperti delle persone dell'organizzazione, con il dispositivo e l'indirizzo da cui arrivano.",
		"title": "Nessuna sessione attiva"
	},
	"end": {
		"all_confirm": "Termina tutte le sessioni",
		"all_description": "Si chiudono subito tutti i suoi accessi aperti, su ogni dispositivo. Per rientrare dovrà accedere di nuovo.",
		"all_title": "Terminare tutte le sessioni di questa persona?",
		"channel_closed": "La connessione in tempo reale è stata chiusa.",
		"channel_pending": "Il server in tempo reale non ha risposto. Il nuovo tentativo è in coda: finché non va a buon fine, la connessione già aperta continua a ricevere.",
		"channel_pending_window_one": "Il server in tempo reale non ha risposto. Il nuovo tentativo è in coda: se non va a buon fine, la connessione già aperta può ricevere ancora per {{count}} minuto al massimo.",
		"channel_pending_window_other": "Il server in tempo reale non ha risposto. Il nuovo tentativo è in coda: se non va a buon fine, la connessione già aperta può ricevere ancora per {{count}} minuti al massimo.",
		"done_one": "{{count}} sessione terminata.",
		"done_other": "{{count}} sessioni terminate.",
		"one_confirm": "Termina la sessione",
		"one_description": "L'accesso da questo dispositivo si chiude subito. Per rientrare, chi lo stava usando dovrà accedere di nuovo.",
		"one_title": "Terminare questa sessione?",
		"own_access_description": "Si chiude anche la sessione che stai usando adesso, e torni alla pagina di accesso.",
		"own_access_title": "Questa persona sei tu",
		"pending": "Chiusura…"
	},
	"no_value": "Non disponibile",
	"page_title": "Sessioni attive",
	"person": {
		"this_session": "Questa sessione",
		"you": "Tu"
	},
	"sign_out": {
		"confirm": "Esci",
		"description": "Questa è la sessione che stai usando adesso. Uscendo torni alla pagina di accesso, e le tue altre sessioni restano aperte.",
		"pending": "Uscita…",
		"title": "Vuoi uscire?"
	},
	"total_one": "{{count}} sessione attiva",
	"total_other": "{{count}} sessioni attive"
}
